module.exports = __webpack_public_path__ + "img/air_pm10.dec8ca6e.png";